
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowUpRight, ArrowDownRight, DollarSign, Users, TrendingUp } from 'lucide-react';

interface BusinessMetricsPanelProps {
  metrics: {
    referralsCount: number;
    completionRate: number;
    conversionRate: number;
    totalEarnings: number;
    pendingEarnings: number;
  };
}

const BusinessMetricsPanel: React.FC<BusinessMetricsPanelProps> = ({ metrics }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Business Metrics</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-500">Total Referrals</span>
              <Users className="h-4 w-4 text-blue-500" />
            </div>
            <div className="text-2xl font-bold">{metrics.referralsCount}</div>
            <div className="text-xs text-green-500 flex items-center mt-1">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              <span>{metrics.completionRate}% completion rate</span>
            </div>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-500">Conversion Rate</span>
              <TrendingUp className="h-4 w-4 text-blue-500" />
            </div>
            <div className="text-2xl font-bold">{metrics.conversionRate}%</div>
            <div className="text-xs text-green-500 flex items-center mt-1">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              <span>5% from last month</span>
            </div>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-500">Total Earnings</span>
              <DollarSign className="h-4 w-4 text-blue-500" />
            </div>
            <div className="text-2xl font-bold">${metrics.totalEarnings}</div>
            <div className="text-xs text-blue-500 flex items-center mt-1">
              <span>${metrics.pendingEarnings} pending</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BusinessMetricsPanel;
